import Toast from './Toast.component';

export default Toast;
